import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography, Collapse, IconButton, Card, CardContent, Box } from '@mui/material';
import UwSubjectivities from 'components/Underwriting/components/UwSubjectivities';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { getSubmissionDetails, getUwReviewSubjectivities } from 'application/redux/selectors';
import { useActions } from 'hooks/useActions';
import * as Actions from 'application/redux/actions';

interface Props {
    readOnly: boolean;
}

const BuildersRiskSubjectivities: React.FC<Props> = ({ readOnly }) => {
    const submission = useSelector(getSubmissionDetails);
    const uwSubjectivities = useSelector(getUwReviewSubjectivities);
    const { uwReviewSaveAllSubjectivities } = useActions(Actions);
    const [showSubjectivities, setShowSubjectivities] = useState<boolean>(false);

    if (submission.isInForce) return null;

    return (
        <>
            <Grid container alignItems={'baseline'} spacing={0}>
                <Grid item>
                    <Typography variant="body1">{`Subjectivities (${uwSubjectivities.length})`}</Typography>
                </Grid>
                <Grid item>
                    <IconButton
                        aria-label="expand subjectivities"
                        size="small"
                        onClick={() => setShowSubjectivities(!showSubjectivities)}
                        style={{ marginLeft: 4 }}
                    >
                        {showSubjectivities ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                    </IconButton>
                </Grid>
            </Grid>
            <Collapse in={showSubjectivities}>
                <UwSubjectivities
                    readonly={readOnly}
                    submissionId={submission.id}
                    initialSubjectivities={uwSubjectivities}
                    onSubjectivitiesChange={(newSubs) => uwReviewSaveAllSubjectivities([...newSubs])}
                />
            </Collapse>
        </>
    );
};

export default React.memo(BuildersRiskSubjectivities);
